import type { HelpFile } from '../../types/help'
import { MyDashboardTestIds } from '../../../testids/MyDashboardTestIds'

export const myDashboardHelp: HelpFile = {
  docPage: '/docs/my-iam/my-access',
  texts: {
    [MyDashboardTestIds.myDashboardPage]:
      'Persönlicher IAM-Arbeitsbereich — Übersicht aktiver Zugriffsprofil-Zuweisungen, offener Anträge und ausstehender Genehmigungen.',
    [MyDashboardTestIds.cardTitleMyAccess]:
      'Zusammenfassung der aktuell aktiven Zugriffsprofil-Zuweisungen.',
    [MyDashboardTestIds.cardTitleMyRequests]:
      'Noch ausstehende Zugriffsanträge für diese Identität.',
    [MyDashboardTestIds.cardTitleMyApprovals]:
      'Zugriffsanträge, die noch nicht entschieden wurden.',
    [MyDashboardTestIds.linkMyAccess]: null,
    [MyDashboardTestIds.linkMyRequests]: null,
    [MyDashboardTestIds.linkMyApprovals]: null,
    [MyDashboardTestIds.approvalsCount]:
      'Anzahl der Zugriffsanträge, die noch auf Genehmigung warten.',
    [MyDashboardTestIds.myAccessCount]:
      'Gesamtzahl der Ihnen gewährten Zugriffsberechtigungen.',
    [MyDashboardTestIds.pendingRequestsCount]:
      'Anzahl der Zugriffsanträge, die auf Ihre Genehmigung warten.',
  },
}
